import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

import { isNil } from 'lodash';

import { Validation } from './enums/validation.enum';

export const greaterThanValidator =
  (minValue: number): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (isNil(control.value) || control.value === '') {
      return null;
    }

    if (control.value < minValue) {
      return { [`${Validation.GreaterThan}${minValue}`]: true };
    }

    return null;
  };
